var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 6,
    viewBox: "0 0 15 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.592 0.288C3.31733 0.288 3.85867 0.445333 4.216 0.76C4.57867 1.07467 4.76 1.52267 4.76 2.104C4.76 2.36533 4.72267 2.616 4.648 2.856C4.57333 3.09067 4.45067 3.304 4.28 3.496C4.11467 3.68267 3.89333 3.832 3.616 3.944C3.33867 4.05067 2.99733 4.104 2.592 4.104H2.16V6H0.616V0.288H2.592ZM2.56 1.536H2.16V2.848H2.464C2.66667 2.848 2.84267 2.79733 2.992 2.696C3.14133 2.58933 3.216 2.40533 3.216 2.144C3.216 1.96267 3.16267 1.816 3.056 1.704C2.94933 1.592 2.784 1.536 2.56 1.536ZM8.19069 6H6.64669V1.552H5.25469V0.288H9.58269V1.552H8.19069V6ZM14.4693 6H10.0213V5.048L12.4933 1.536H10.0773V0.288H14.4053V1.24L11.9333 4.752H14.4693V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtz);
export default __webpack_public_path__ + "static/media/ptz.a924810764c6f367a7f111c69b2ecb5d.svg";
export { ForwardRef as ReactComponent };